import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=d5acd0a2&scoped=true&lang=pug&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"
import style0 from "./feedback.vue?vue&type=style&index=0&id=d5acd0a2&prod&lang=sass&scoped=true&"
import style1 from "./feedback.vue?vue&type=style&index=1&id=d5acd0a2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5acd0a2",
  null
  
)

export default component.exports